import $1jmnO$intltoastarAEmjs from "../intl/toast/ar-AE.mjs";
import $1jmnO$intltoastbgBGmjs from "../intl/toast/bg-BG.mjs";
import $1jmnO$intltoastcsCZmjs from "../intl/toast/cs-CZ.mjs";
import $1jmnO$intltoastdaDKmjs from "../intl/toast/da-DK.mjs";
import $1jmnO$intltoastdeDEmjs from "../intl/toast/de-DE.mjs";
import $1jmnO$intltoastelGRmjs from "../intl/toast/el-GR.mjs";
import $1jmnO$intltoastenUSmjs from "../intl/toast/en-US.mjs";
import $1jmnO$intltoastesESmjs from "../intl/toast/es-ES.mjs";
import $1jmnO$intltoastetEEmjs from "../intl/toast/et-EE.mjs";
import $1jmnO$intltoastfiFImjs from "../intl/toast/fi-FI.mjs";
import $1jmnO$intltoastfrFRmjs from "../intl/toast/fr-FR.mjs";
import $1jmnO$intltoastheILmjs from "../intl/toast/he-IL.mjs";
import $1jmnO$intltoasthrHRmjs from "../intl/toast/hr-HR.mjs";
import $1jmnO$intltoasthuHUmjs from "../intl/toast/hu-HU.mjs";
import $1jmnO$intltoastitITmjs from "../intl/toast/it-IT.mjs";
import $1jmnO$intltoastjaJPmjs from "../intl/toast/ja-JP.mjs";
import $1jmnO$intltoastkoKRmjs from "../intl/toast/ko-KR.mjs";
import $1jmnO$intltoastltLTmjs from "../intl/toast/lt-LT.mjs";
import $1jmnO$intltoastlvLVmjs from "../intl/toast/lv-LV.mjs";
import $1jmnO$intltoastnbNOmjs from "../intl/toast/nb-NO.mjs";
import $1jmnO$intltoastnlNLmjs from "../intl/toast/nl-NL.mjs";
import $1jmnO$intltoastplPLmjs from "../intl/toast/pl-PL.mjs";
import $1jmnO$intltoastptBRmjs from "../intl/toast/pt-BR.mjs";
import $1jmnO$intltoastptPTmjs from "../intl/toast/pt-PT.mjs";
import $1jmnO$intltoastroROmjs from "../intl/toast/ro-RO.mjs";
import $1jmnO$intltoastruRUmjs from "../intl/toast/ru-RU.mjs";
import $1jmnO$intltoastskSKmjs from "../intl/toast/sk-SK.mjs";
import $1jmnO$intltoastslSImjs from "../intl/toast/sl-SI.mjs";
import $1jmnO$intltoastsrSPmjs from "../intl/toast/sr-SP.mjs";
import $1jmnO$intltoastsvSEmjs from "../intl/toast/sv-SE.mjs";
import $1jmnO$intltoasttrTRmjs from "../intl/toast/tr-TR.mjs";
import $1jmnO$intltoastukUAmjs from "../intl/toast/uk-UA.mjs";
import $1jmnO$intltoastzhCNmjs from "../intl/toast/zh-CN.mjs";
import $1jmnO$intltoastzhTWmjs from "../intl/toast/zh-TW.mjs";

var $f3e1a27213f96b5b$exports = {};


































$f3e1a27213f96b5b$exports = {
    "ar-AE": $1jmnO$intltoastarAEmjs,
    "bg-BG": $1jmnO$intltoastbgBGmjs,
    "cs-CZ": $1jmnO$intltoastcsCZmjs,
    "da-DK": $1jmnO$intltoastdaDKmjs,
    "de-DE": $1jmnO$intltoastdeDEmjs,
    "el-GR": $1jmnO$intltoastelGRmjs,
    "en-US": $1jmnO$intltoastenUSmjs,
    "es-ES": $1jmnO$intltoastesESmjs,
    "et-EE": $1jmnO$intltoastetEEmjs,
    "fi-FI": $1jmnO$intltoastfiFImjs,
    "fr-FR": $1jmnO$intltoastfrFRmjs,
    "he-IL": $1jmnO$intltoastheILmjs,
    "hr-HR": $1jmnO$intltoasthrHRmjs,
    "hu-HU": $1jmnO$intltoasthuHUmjs,
    "it-IT": $1jmnO$intltoastitITmjs,
    "ja-JP": $1jmnO$intltoastjaJPmjs,
    "ko-KR": $1jmnO$intltoastkoKRmjs,
    "lt-LT": $1jmnO$intltoastltLTmjs,
    "lv-LV": $1jmnO$intltoastlvLVmjs,
    "nb-NO": $1jmnO$intltoastnbNOmjs,
    "nl-NL": $1jmnO$intltoastnlNLmjs,
    "pl-PL": $1jmnO$intltoastplPLmjs,
    "pt-BR": $1jmnO$intltoastptBRmjs,
    "pt-PT": $1jmnO$intltoastptPTmjs,
    "ro-RO": $1jmnO$intltoastroROmjs,
    "ru-RU": $1jmnO$intltoastruRUmjs,
    "sk-SK": $1jmnO$intltoastskSKmjs,
    "sl-SI": $1jmnO$intltoastslSImjs,
    "sr-SP": $1jmnO$intltoastsrSPmjs,
    "sv-SE": $1jmnO$intltoastsvSEmjs,
    "tr-TR": $1jmnO$intltoasttrTRmjs,
    "uk-UA": $1jmnO$intltoastukUAmjs,
    "zh-CN": $1jmnO$intltoastzhCNmjs,
    "zh-TW": $1jmnO$intltoastzhTWmjs
};


export {$f3e1a27213f96b5b$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
